import { useState, useEffect } from 'react'
import { Box, Button, Text, VStack, Select, HStack } from '@chakra-ui/react'

interface Repository {
  id: number
  name: string
  full_name: string
}

export const CodeConfig = () => {
  const [isConnecting, setIsConnecting] = useState(false)
  const [isConnected, setIsConnected] = useState(false)
  const [repositories, setRepositories] = useState<Repository[]>([])
  const [selectedRepo, setSelectedRepo] = useState<string>('')
  const [error, setError] = useState<string | null>(null)

  // Check connection status on mount AND when URL changes
  useEffect(() => {
    checkGitHubConnection()
    
    // Also check if we need to switch to the code tab
    const hash = window.location.hash
    if (hash.includes('github=success')) {
      window.location.hash = 'code'
    }
  }, [])

  const checkGitHubConnection = async () => {
    try {
      console.log('Checking GitHub connection...')
      const response = await fetch('http://localhost:3001/api/github/repos', {
        credentials: 'include'
      })
      
      if (response.ok) {
        console.log('GitHub connected successfully')
        const repos = await response.json()
        setRepositories(repos)
        setIsConnected(true)
        // Clean up URL while preserving the code tab
        const currentHash = window.location.hash
        if (currentHash.includes('?')) {
          window.history.replaceState({}, '', `/config#code`)
        }
      } else {
        console.log('GitHub not connected:', response.status)
        setIsConnected(false)
      }
    } catch (err) {
      console.error('Failed to check GitHub connection:', err)
      setError('Failed to verify GitHub connection')
      setIsConnected(false)
    }
  }

  const handleGitHubConnect = () => {
    setIsConnecting(true)
    const GITHUB_CLIENT_ID = import.meta.env.VITE_GITHUB_CLIENT_ID
    const redirectUri = 'http://localhost:3001/api/auth/github/callback'
    
    window.location.href = `https://github.com/login/oauth/authorize?client_id=${GITHUB_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=repo read:user`
  }

  const handleRepoSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedRepo(event.target.value)
  }

  const handleImplement = () => {
    if (!selectedRepo) return
    
    console.log('Implementing repo:', selectedRepo)
    
    // Store the selected repo
    localStorage.setItem('selectedRepo', selectedRepo)
    
    // Force a page reload when switching to model tab
    window.location.href = '/config#model'
    window.location.reload()
  }

  return (
    <VStack spacing={4} align="center" width="100%" maxW="600px" mx="auto">
      {!isConnected ? (
        <Button
          onClick={handleGitHubConnect}
          isLoading={isConnecting}
          colorScheme="blue"
          size="md"
          width="200px"
        >
          Connect GitHub Account
        </Button>
      ) : (
        <Box width="100%">
          <Text mb={2} color="green.500" textAlign="center">
            ✓ Connected to GitHub
          </Text>
          {repositories.length > 0 ? (
            <HStack spacing={4} width="100%" justify="center">
              <Select 
                placeholder="Select a repository"
                value={selectedRepo}
                onChange={handleRepoSelect}
                width="300px"
                size="md"
              >
                {repositories.map(repo => (
                  <option key={repo.id} value={repo.full_name}>
                    {repo.full_name}
                  </option>
                ))}
              </Select>
              {selectedRepo && (
                <Button
                  colorScheme="green"
                  size="md"
                  onClick={handleImplement}
                >
                  Implement as Model
                </Button>
              )}
            </HStack>
          ) : (
            <Text textAlign="center">Loading repositories...</Text>
          )}
        </Box>
      )}
      {error && (
        <Text color="red.500" textAlign="center">
          {error}
        </Text>
      )}
    </VStack>
  )
} 